module.exports = __webpack_public_path__ + "img/加好友截图-1.000da087.png";